module.exports = __webpack_public_path__ + "img/VZ.6b49feca.png";